const animatedInteger = (startValue=0, endValue=0, animationTiming=800) => {
    let startTime = new Date().valueOf();
    let num = null;
    let requestAnimationFrameId = null;
    let animate = (callback) =>  {
        let currentTime = new Date().valueOf();
        let scheduleTime = currentTime - startTime;
        num = ((scheduleTime / animationTiming) * (endValue - startValue) + startValue).toFixed(0);
        if(endValue - startValue > 0 ? num >= endValue : num <= endValue){
            num = endValue;
            // cancelAnimationFrame(requestAnimationFrameId);
        }else{
            requestAnimationFrameId = requestAnimationFrame(animate.bind(null,callback));
        }
        callback && callback(parseFloat(num))
    }
    return {
        animate:(startValue == endValue) ? () => {} : animate
    };
}
export default {
    methods: {
        toScrollTop(toNum){
            let startNum = document.documentElement.scrollTop;
            animatedInteger(startNum, toNum, startNum / 10).animate((num) => {
                window.scrollTo(0,num)
            })
        },
        defaultSrc(eImg, src){
            switch(src){
                // case "equipment":
                //     eImg.src = require("@/assets/img/def-equipment.png")
                //     break;
                default:
                    // eImg.src = require("@/assets/img/banner-bg02.png")
                    break;
            }
        },
        numSplit(num,maxLength=5){ //补位
            let num_split = num.toString().split("");
            for(;num_split.length < maxLength;){
                num_split.unshift("0")
            }
            if(num_split.length < maxLength){
                num_split.unshift("0".repeat(maxLength - num_split.length));
            }
            return num_split.join("");
        },
        fullScreen:function(el, callback){ //设置全屏
            // let originalStyle;             
            // webkitfullscreenchange fullscreenchange mozfullscreenchange MSFullscreenChange
            let isFullscreen = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
            if (!isFullscreen) { //进入全屏,多重短路表达式
                (el.requestFullscreen && el.requestFullscreen()) ||
                (el.mozRequestFullScreen && el.mozRequestFullScreen()) ||
                (el.webkitRequestFullscreen && el.webkitRequestFullscreen()) || 
                (el.msRequestFullscreen && el.msRequestFullscreen());
            } else { //退出全屏,三目运算符
                document.exitFullscreen ? document.exitFullscreen() :
                document.mozCancelFullScreen ? document.mozCancelFullScreen() :
                document.webkitExitFullscreen ? document.webkitExitFullscreen() : '';
            }       
            document.onfullscreenchange = document.onmozfullscreenchange = document.onwebkitfullscreenchange = document.onMSFullscreenChange = () => {
                let isScreen = (document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen) ? true : false;
                // if(isScreen){
                //     originalStyle = el.getAttribute("style");
                //     el.style.width = window.outerWidth * 0.5;
                //     el.style.height = window.outerHeight * 0.5;
                //     el.style.transform = "translateX(50%) translateY(50%) scale(2)";
                // }else{
                //     el.setAttribute("style", originalStyle);
                // }
                callback && callback(isScreen);
            }  
        },     
    },
}